var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinPointer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 69,
    viewBox: "0 0 61 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_578_25162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4606 13.0394C24.662 5.83795 36.338 5.83795 43.5394 13.0394C49.6902 19.1902 50.7064 28.8028 45.9776 36.1037L32.1732 57.4167C31.3875 58.6298 29.6125 58.6298 28.8268 57.4167L15.0224 36.1037C10.2936 28.8028 11.3098 19.1902 17.4606 13.0394Z",
    fill: "url(#paint0_radial_578_25162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4606 13.0394C24.662 5.83795 36.338 5.83795 43.5394 13.0394C49.6902 19.1902 50.7064 28.8028 45.9776 36.1037L32.1732 57.4167C31.3875 58.6298 29.6125 58.6298 28.8268 57.4167L15.0224 36.1037C10.2936 28.8028 11.3098 19.1902 17.4606 13.0394Z",
    fill: "url(#paint1_radial_578_25162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.528 19.2351C26.4831 14.28 34.5169 14.28 39.472 19.2351C43.5554 23.3185 44.3664 29.6442 41.4452 34.6257L31.7901 51.09C31.2122 52.0754 29.7878 52.0754 29.2099 51.09L19.5548 34.6257C16.6336 29.6442 17.4446 23.3185 21.528 19.2351Z",
    fill: "url(#paint2_radial_578_25162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.528 19.2351C26.4831 14.28 34.5169 14.28 39.472 19.2351C43.5554 23.3185 44.3664 29.6442 41.4452 34.6257L31.7901 51.09C31.2122 52.0754 29.7878 52.0754 29.2099 51.09L19.5548 34.6257C16.6336 29.6442 17.4446 23.3185 21.528 19.2351Z",
    fill: "url(#paint3_radial_578_25162)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_578_25162",
    x: -4.63154,
    y: 0,
    width: 70.2631,
    height: 70.2631,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.13154
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.56577
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_578_25162"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_578_25162",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_578_25162",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.3272 29.8273) rotate(179.696) scale(59.684 3658.23)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C72D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484416,
    stopColor: "#D23760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D23755"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_578_25162",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.3272 29.8273) rotate(179.696) scale(59.684 3658.23)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C72D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484416,
    stopColor: "#D23760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D23755"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_578_25162",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.614 30.3771) rotate(179.696) scale(40.248 2466.93)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C72D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484416,
    stopColor: "#D23760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D23755"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_578_25162",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.1019 22.9441) rotate(28.393) scale(26.9788 1653.62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6114D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484416,
    stopColor: "#D23760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94878"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinPointer);
export default __webpack_public_path__ + "static/media/spin-pointer.e56d58a67ae35ffade42b18967f69d3c.svg";
export { ForwardRef as ReactComponent };